import {TableCmp} from "./components/Table/TableCmp.js";
import {StructureSearchCmp} from "./components/StructureSearch/StructureSearchCmp.js";
import IndexPageDiContext from "./components/IndexPageDiContext.js";
import HttpClient from "./js/util/HttpClient.js";
import {getApiRootPath} from "./js/util/CommonUtils.js";
import DialogUtils from "./js/util/DialogUtils.js";
import {getQueryParamFromUrl, getStructureIdsFromUrl} from "./js/util/UrlUtils.js";
import {StructureId} from "./js/struct/StructureId.js";
import PageIterator from "./js/util/PageIterator.js";

window.onload = async () => {
    await renderPage();
    window.onpopstate = async () => {
        const dialogs = document.querySelectorAll('dialog');
        for (const dialog of dialogs){
            dialog.remove()
        }
        await renderPage();
    };
}

async function renderPage(){
    DialogUtils.initMutationObserverToPreventScrollWhenDialogIsOpened()
    const currentPagePath = '';

    const di = new IndexPageDiContext(new HttpClient(getApiRootPath(currentPagePath)));
    const eventRepository = di.getEventRepository();
    const structRepository = di.getStructRepository();

    const header = di.getHeader();
    header.show(document.querySelector('.event-page-header'));

    const tooltipManager = di.getTooltipManager();
    tooltipManager.init(document.querySelector('.tooltip-block'))

    let pageIterator;

    const table = new TableCmp();
    table.init(document.body.querySelector('main'));
    await table.show();

    const eventsToSearch = getQueryParamFromUrl('events');
    const contextToSearch = getQueryParamFromUrl('context');
    const structureSearch = new StructureSearchCmp(structRepository);
    structureSearch.init(document.body.querySelector('.structure-search'));
    structureSearch.onStructureIdsChanged(/** @param {string[]} idsFound */ async (idsFound) => {
        let idsToFindEventsFor = idsFound;
        // 2 reasons why the IDs could be empty:
        //  a) We just opened the landing page w/o searching for anything. Then we want to pass empty array to the
        //     repository - it'll find us all the recent events.
        //  b) We put `?structureIds=...` in the URL, but it doesn't exist. In this case requesting the forms of that
        //     ID returns an empty array, which is passed here. In this scenario we want to depict no events because
        //     the ID was specified explicitly, and we don't really have the events for that ID. That's why we check
        //     the URL param - to see whether it was actually passed.
        if (!idsToFindEventsFor || idsToFindEventsFor.length === 0)
            idsToFindEventsFor = getStructureIdsFromUrl();
        pageIterator = new PageIterator(eventRepository.loadEvents.bind(eventRepository, idsToFindEventsFor, eventsToSearch, contextToSearch))
        table.loadFirstPage(await pageIterator.getNext());
    })
    // now run the initial search:
    const idsToSearch = getStructureIdsFromUrl();
    if(idsToSearch.length > 0) {
        const parentIds = new Set();
        const structureIds = [];
        for (const id of idsToSearch){
            const parent = id.split('-')[0];
            structureIds.push(new StructureId(id, '', '', '', parent));
            parentIds.add(parent)
        }
        await structureSearch.searchByIds([...parentIds], structureIds);
    } else {//just find all the last events
        pageIterator = new PageIterator(eventRepository.loadEvents.bind(eventRepository, [], eventsToSearch, contextToSearch))
        table.loadFirstPage(await pageIterator.getNext());
    }

    let isLoading = false;

    window.onscroll = async function (_) {
        if (isLoading) return Promise.resolve();
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 2) {
            isLoading = true;
            table.loadNextPage(await pageIterator.getNext());
            isLoading = false;
        }
    };
}